import { EMPTY, Observable } from 'rxjs';
import { catchError, filter, map, take, tap } from 'rxjs/operators';

// Popup blockers only allow window.open inside the click handler, so the tab is opened blank right away
// and pointed at the URL once it resolves. Call it synchronously from the click stream, never after an async hop.
export const openInNewTabWhenResolved = (url$: Observable<string | null | undefined>): Observable<never> => {
  const tab = window.open('', '_blank');
  if (tab) { tab.opener = null; }
  return url$.pipe(
    take(1),
    tap((url) => {
      if (!tab) {
        if (url) { window.open(url, '_blank', 'noopener,noreferrer'); }
        return;
      }
      if (url) {
        tab.location.href = url;
      } else {
        tab.close();
      }
    }),
    catchError(() => {
      tab?.close();
      return EMPTY;
    }),
    map(() => null),
    filter((v): v is never => v !== null)
  );
};
